import React, { useState } from 'react';

import { initialValues, SearchFormValues, searchSchema } from '../schema';
import { Button } from '@/components/ui/button';

import { AritoFormV2, BottomActionBarV2, DialogV2, AritoIcon } from '@/components/custom/erp';
import { AccountModel, KhachHang } from '@/types/schemas';
import BasicInfo from './BasicInfo';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: SearchFormValues) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const [openAlertForm, setOpenAlertForm] = useState(false);
  const [khachHang, setKhachHang] = useState<KhachHang | null>(null);
  const [taiKhoan, setTaiKhoan] = useState<AccountModel | null>(null);
  const handleSubmit = (data: SearchFormValues) => {
    onSearch(data);
    setOpenAlertForm(true);
  };

  const handleDirectSubmit = () => {
    onClose();
    setOpenAlertForm(true);
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title='Tính lại số dư tức thời theo tài khoản'
        maxWidth='lg'
        disableBackdropClose={false}
        disableEscapeKeyDown={false}
        titleIcon={<AritoIcon icon={12} />}
      >
        <AritoFormV2
          mode='add'
          hasAritoActionBar={false}
          schema={searchSchema}
          initialData={initialValues}
          onSubmit={handleSubmit}
          className='w-full'
          headerFields={
            <BasicInfo
              khachHang={khachHang}
              taiKhoan={taiKhoan}
              setKhachHang={setKhachHang}
              setTaiKhoan={setTaiKhoan}
            />
          }
          bottomBar={<BottomActionBarV2 onSubmit={handleDirectSubmit} onClose={onClose} mode={'add'} />}
        />
      </DialogV2>

      {/* Alert Form */}
      {openAlertForm && (
        <DialogV2
          title='Cảnh báo'
          titleIcon={<AritoIcon icon={260} />}
          showFullscreenToggle={false}
          actions={
            <>
              <Button
                onClick={() => {
                  setOpenAlertForm(false);
                  onClose();
                }}
                className='bg-[rgba(15,118,110,0.9)] text-white hover:bg-[rgba(15,118,110,1)]'
              >
                <AritoIcon icon={884} />
                <span className='ml-1'>Đồng ý</span>
              </Button>
            </>
          }
        >
          <p className='mr-14 p-8'>Chương trình đã thực hiện xong</p>
        </DialogV2>
      )}
    </>
  );
};

export default InitialSearchDialog;
